angular.module('invoice')
    .controller('InvoiceProjectBgtEditPositionController', function ($scope, data, toastr, $rootScope, $uibModalInstance, modals, Invoice, InvoiceService, InvoiceProjectBgt) {
        this.InvoiceService = InvoiceService

        this.$onInit = () => {
            this.totalsByCurrency = data.totalsByCurrency || []
            this.entityId = data.entityId
            this.revisionId = data.revisionId
            if(data.item) {
                this.item = angular.copy(data.item)
            }
            else {
                this.item = {
                    id: null,
                    currency: 'PLN'
                }
            }
            this.item.currency = this.item.currency || 'PLN'
            this.onCurrencyChanged()
            $scope.$watch(() => this.item && this.item.currency, (currency, previousCurrency) => {
                if (currency && currency !== previousCurrency) {
                    this.onCurrencyChanged()
                }
            })
        }

        this.onCurrencyChanged = () => {
            this.currency = this.item.currency
            let total = this.totalsByCurrency.find(total => total.currency === this.currency)
            this.totalNet = total ? total.amount : 0
            this.onAmountChanged()
        }

        this.onAmountChanged = (c) => {
            this.percentage = InvoiceService.percentage(this.item.amount, this.totalNet) || 0
            this.totalAfter = InvoiceService.sumDecimal([this.totalNet, this.item.amount || 0])
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = InvoiceProjectBgt.update({entityId: this.entityId, revisionId: this.revisionId}, this.item).$promise
            } else {
                promise = InvoiceProjectBgt.save({entityId: this.entityId, revisionId: this.revisionId}, this.item).$promise
            }
            return promise.then(result => {
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
